import { render, staticRenderFns } from "./PackageContents.vue?vue&type=template&id=f1997a54&lang=pug"
import script from "./PackageContents.vue?vue&type=script&lang=js"
export * from "./PackageContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports